import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import Footer from "./component/Footer";
import CartView from "./component/CartView";
import { DropDownButton } from "./component/dropdownv2";
import PopupProduct from "./component/PopupProduct";
import MegaMenu from "./component/Mega";
import StoreHelmet from "./component/StoreHelment";
import TabV3 from "./component/TabV3";
import CalendarV2 from "./component/CalendarV2";
import { ToastProvider, useToast } from "./component/ToaserNew";
import CategoryView from "./component/CategoryItem";
import { PlaceholderCard, LandingHeader } from "./component";
import { axios, productStats } from "./Network";
import CardV2 from "./component/CardV2";
import toast, { Toaster } from "react-hot-toast";
import ContentLoader from "react-content-loader";
import moment from "moment";
import "moment-timezone";
import { setHours, setMinutes } from "date-fns";
import ReactGA from "react-ga";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams, useHistory, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

const FloatingButton = React.memo(
  ({
    category,
    selectedDate,
    cart,
    displayColorBG,
    navigateCategory,
    navigateToCalendar,
    openCartView,
    selectedDateV2,
    offset,
  }) => {
    const formattedDateLong = React.useCallback(
      () => moment(selectedDateV2.date).format("MMM DD, YYYY").toString(),
      [selectedDateV2.date],
    );

    const formattedDateShort = React.useCallback(
      () => moment(selectedDateV2.date).format("MM/DD/YY").toString(),
      [selectedDateV2.date],
    );

    return (
      <div
        style={{
          borderColor: displayColorBG(),
          opacity: offset <= 0 ? 0 : 1,
          visibility: offset <= 0 ? "hidden" : "visible",
          transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
        }}
        className="border grid-cols-20 lg:w-1/4 w-9/12 md:w-9/12 fixed bottom-8 left-1/2 transform flex -translate-x-1/2 bg-white text-white text-xs py-2 px-4 rounded-full w-[90%] shadow-lg transition-all duration-300 z-[49]"
      >
        <button
          onClick={() => navigateCategory()}
          className="flex align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full  transition-all duration-300 z-50"
        >
          <img
            src={"/square.and.pencil@3x.png"}
            className=""
            style={{
              height: 16,
              width: 16,
              marginLeft: 20,
            }}
          />
          <span className="m-2 text-black mr-4">
            {category.substring(0, 5)}...
          </span>
        </button>

        <button
          onClick={() => navigateToCalendar()}
          className="flex align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full  transition-all duration-300 z-50"
        >
          <img
            alt="calendar"
            src={"/calendar@3x.png"}
            className=""
            style={{
              height: 16,
              width: 16,
              marginLeft: 20,
            }}
          />
          <span className="lg:block hidden  m-2 text-black mr-4">
            {moment(selectedDate.date).format("MMM DD, YYYY").toString()}
          </span>

          <span className="lg:hidden block m-2 text-black mr-4">
            {moment(selectedDateV2.date).format("MM/DD/YY").toString()}
          </span>
        </button>

        <button
          onClick={() => openCartView()}
          className="flex ml-4 align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full transition-all duration-300 z-50"
        >
          <img
            src={cart.length ? "/bag.fill@3x.png" : "/bag@3x.png"}
            className=""
            style={{
              height: 16,
              width: 16,
              marginLeft: 10,
            }}
          />
          <div className="bg-white rounded-full w-6 h-6 text-red-700 text-sm flex  justify-center align-middle items-center">
            {cart.length}
          </div>
        </button>
      </div>
    );
  },
);
function DatePickerComponent({
  date,
  onChangeDate,
  navigator,
  store,
  displayColorBG,
}) {
  const [isValid, setValid] = useState(false);
  const bookedStyle = {
    border: "2px solid currentColor",
    backgroundColor: "#0652DD",
    color: "white",
  };
  let displayError = false;

  async function recordProductStats(e) {
    try {
      const data = {
        storeOwner: "PaculbaFlowerShop",
        cType: "calendarBehavior",
        cName: "website",
        userPreferredDate: moment(e).format("MMMM DD YYYY").toString(),
        date: new Date(),
      };
      const response = await productStats.put("/api/tracker", data);
      return response;
    } catch (error) {}
  }

  const validateDate = (e) => {
    if (moment(e).isBefore(new Date())) {
      toast("Please try again later..");
      setValid(true);
      displayError = true;
    } else {
      recordProductStats(e);
      setValid(false);
      displayError = false;
      onChangeDate(e);
    }
  };
  const filterUnavailableDates = () => {
    try {
      return store.storeOptions.businessHours.unAvailableDates.map((item) => {
        return moment(item).toDate();
      });
    } catch {
      return [];
    }
  };
  const displayFooter = () => {
    let invalidContent = (
      <p className="text-xs animate-pulse text-red-500">
        {"Please select future date"}
      </p>
    );
    let validContent = <p className="text-xs">{""}</p>;
    return !isValid ? null : invalidContent;
  };
  return (
    <DayPicker
      mode="single"
      value={date}
      defaultMonth={new Date()}
      fromMonth={new Date()}
      modifiers={{ booked: [date] }}
      modifiersStyles={{ booked: bookedStyle }}
      disabled={filterUnavailableDates()}
      today={new Date()}
      styles={{
        caption: { color: "#0652DD" },
      }}
      footer={displayFooter()}
      onDayClick={(e) => validateDate(e)}
      min={new Date()}
      required
    />
  );
}
ReactGA.initialize(process.env.REACT_APP_STORE_REACT_GA, {
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123,
  },
});
var timeInManila = moment.tz("Asia/Manila");
const MyLoader = (props) => (
  <ContentLoader viewBox="0 0 400 31" height={200} width={"auto"} {...props}>
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="5" />
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="15" />
    <circle cx="388" cy="12" r="12" />
    <rect height="24" rx="0" ry="0" width="24" x="0" y="0" />
  </ContentLoader>
);

var id = process.env.REACT_APP_STORE_ID;
var primaryProduct = process.env.REACT_APP_DEFAULT_PRIMARY_PRODUCT;
var secondProduct = process.env.REACT_APP_DEFAULT_SECOND_PRODUCT;

// [Flux-Bouquet,Lux-Arrangements]
function App() {
  const storeRef = useRef(null);

  const { showToast } = useToast();
  // Inside your Store component
  const { param1, param2 } = useParams();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryFromQuery = queryParams.get("category");
  const subFromQuery = queryParams.get("sub");

  // Logic to determine what param1 and param2 represent
  const isCategory =
    (param1 && categories.some((cat) => cat.name === param1)) ||
    (categoryFromQuery &&
      categories.some((cat) => cat.name === categoryFromQuery));
  const isSubcategory =
    (param2 && subcategories.some((sub) => sub.name === param2)) ||
    (subFromQuery && subcategories.some((sub) => sub.name === subFromQuery));
  const isProduct = param1 && !isCategory;

  const [open, setOpen] = useState(false);
  const [isActiveSearch, setActiveSearch] = useState(false);
  const [isDisplaySearched, setDisplaySearched] = useState(false);
  const [searchedResults, setSearchResults] = useState([]);
  const [searchedItem, setSearchedItem] = useState(null);
  const [status, setStatus] = useState(false);
  const [suggestStatus, setSuggestStatus] = useState(false);
  const [cart, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);
  let [isOpen, setIsOpen] = useState(true);
  const [scroll, setScroll] = useState(0);
  const [didUpdate, setUpdate] = useState(true);
  const [product, setProducts] = useState([]);
  const [addons, setAddonProduct] = useState([]);
  const [suggestedProduct, setSuggestedProduct] = useState([]);
  const [topItems, setTopItems] = useState([]);
  const [category, setSelectedCategory] = useState(primaryProduct); //
  const [categories, setCategory] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const subcategoriesContainerRef = useRef(null);
  const categoriesContainerRef = useRef(null);
  const dummyCardsContainerRef = useRef(null);
  const [storeDetails, setStoreInfo] = useState(null);
  const [hasVoucher, setHasVoucher] = useState(false);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const categoryRef = useRef(null);
  const calendarRef = useRef(null);
  const cartViewRef = useRef();
  const [viewProduct, setCurrentView] = useState(null);
  const [selectedDate, setSelectedDate] = useState({ date: new Date() });
  const listInnerRef = useRef();
  const [offset, setOffset] = useState(0);
  const [currentPage, setPage] = useState(4);
  const mainCategory = useRef();
  const [displayCalendar, setDisplayCalendar] = useState(false);
  const [selectedDateV2, setSelectedDateV2] = useState(
    moment(setHours(setMinutes(new Date(), 0), 9))
      .add(4, "days")
      .tz("Asia/Manila")
      .toDate(),
  );
  const [dashboardDetails, setDashboardSettings] = useState([]);
  const [suggesteItem, setSuggestedItem] = useState({
    type: secondProduct,
    displayName: secondProduct,
    title: secondProduct,
  });

  var addonsID = "Tart-Addons";
  const finder = (e) => {
    let userSeletedDate = localStorage.getItem("userQ");
    var date = JSON.parse(userSeletedDate);
    if (e != undefined) {
      var filterd = e.filter(
        (data) =>
          moment(data.date).format("YYYY-MM-DD") ===
          moment(date.date).format("YYYY-MM-DD"),
      );
      if (filterd.length) {
        return filterd[0];
      }
    }
  };

  const productFilter = (e, state) => {
    var filtered = [];
    e.map((item) => {
      var price = finder(item.priceSurgesDates);
      if (
        item.priceSurgesDates != undefined &&
        item.priceSurgesDates.length &&
        price != undefined
      ) {
        console.log();
        item.basePrice = item.price;
        item.price = price.price;

        filtered.push(item);
      } else {
        filtered.push(item);
      }
    });
    state(filtered);
    setStatus(false);
    setSuggestStatus(false);
  };
  const setOneDayAdvanceDelivery = () => {
    var startDate = moment(setHours(setMinutes(new Date(), 0), 13))
      .add(1, "days")
      .toDate();
    var searchDetails = {
      date: startDate,
      type: primaryProduct,
    };
    setSelectedDate(startDate);
    localStorage.setItem("userQ", JSON.stringify(searchDetails));
  };
  React.useEffect(async () => {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    let userSeletedDate = localStorage.getItem("userQ");
    var date = JSON.parse(userSeletedDate);
    if (date == undefined) {
      setOneDayAdvanceDelivery();
    } else {
      if (
        moment(date.date).add(1, "days").toDate() <=
        moment(setHours(setMinutes(new Date(), 0), 13))
          .add(1, "days")
          .toDate()
      ) {
        setOneDayAdvanceDelivery();
      } else {
        setSelectedDate(date);
      }
    }

    try {
      let scrollTimeout;
      const handleScroll = () => {
        listInnerRef.current = window.pageYOffset;

        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(() => {
          setOffset(window.pageYOffset);
        }, 16);
      };

      window.addEventListener("scroll", handleScroll);
      fetchStoreProduct(category, 4).then((data) => {
        if (data === undefined) {
          toast("Please try again later..");
        } else {
          productFilter(data.data.results, setProducts);
          setRandomItems(data.data.results);
        }
      });
      fetchStoreProduct(suggesteItem.type, 4).then((data) => {
        if (data === undefined) {
          toast("Please try again later..");
        } else {
          productFilter(data.data.results, setSuggestedProduct);
          setRandomItems(data.data.results);
        }
      });
      loadProductCategory();
      let existingCart = localStorage.getItem("UserCart");
      if (existingCart !== null) {
        let jsonCart = JSON.parse(existingCart);
        setCartItems(jsonCart);
      }

      let dashboardDetails = await fetchStoreSettings();
      console.log("dashboardDetails", dashboardDetails.data.results);

      setDashboardSettings(dashboardDetails.data.results[0].dashboardOptions);
    } catch (error) {
      console.log("error", error);
      toast("Please try again later..");
    }

    // Cleanup function
    return () => {
      // window.removeEventListener('scroll', handleScroll);
      // if (scrollTimeout) {
      //   clearTimeout(scrollTimeout);
      // }
    };
  }, []);

  // Handle URL parameters when component loads or URL changes
  useEffect(() => {
    const categoryToLoad = categoryFromQuery || param1;
    const subcategoryToLoad = subFromQuery || param2;

    // Only run when categories are loaded AND we have URL parameters
    if (categories.length > 0 && (categoryToLoad || subcategoryToLoad)) {
      // Check if we have a valid category from URL
      if (
        categoryToLoad &&
        categories.some(
          (cat) => cat.name === categoryToLoad || cat.title === categoryToLoad,
        )
      ) {
        const foundCategory = categories.find(
          (cat) => cat.name === categoryToLoad || cat.title === categoryToLoad,
        );
        if (foundCategory) {
          setSelectedCategory(foundCategory.title);

          // Load subcategories for this category
          if (foundCategory.items) {
            setSubcategories(foundCategory.items);
          }

          // Load products for this category
          fetchStoreProduct(foundCategory.title, 1).then((data) => {
            setProducts([]);
            productFilter(data.data.results, setProducts);
          });
        }
      }

      // Check if we have a valid subcategory from URL
      // if (subcategoryToLoad && subcategories.length > 0) {
      //   const foundSubcategory = subcategories.find(sub => sub.name === subcategoryToLoad || sub.title === subcategoryToLoad);
      //   if (foundSubcategory && foundSubcategory.title !== selectedSubcategory) {
      //     setSelectedSubcategory(foundSubcategory.title);

      //     // Load products for this subcategory
      //     fetchStoreProduct(foundSubcategory.title, currentPage).then((data) => {
      //       setProducts([]);
      //       productFilter(data.data.results, setProducts);
      //     });
      //   }
      // }
    }
  }, [param1, param2, categoryFromQuery, subFromQuery, categories.length]);
  useEffect(() => {}, [selectedDateV2]);
  function navigateTo() {
    storeRef.current.scrollIntoView();
  }
  function addRemoveItem(e, status) {
    if (status) {
      // toast.success(`${e.title.substring(0, 4)}... has been added `);
      showToast({
        title: `${e.title.substring(0, 4)}`,
        description: "Has been added to cart",
      });
      setCartItems((prevArray) => [...prevArray, e]);
      let existingCart = cart;
      if (cart.length) {
        let existingCart = localStorage.getItem("UserCart");
        let jsonCart = JSON.parse(existingCart);
        jsonCart.push(e);
        localStorage.setItem("UserCart", JSON.stringify(jsonCart));
        localStorage.setItem("UserCart_Cache", JSON.stringify(jsonCart));
      } else {
        let initialCart = [];
        initialCart.push(e);
        localStorage.setItem("UserCart", JSON.stringify(initialCart));
        localStorage.setItem("UserCart_Cache", JSON.stringify(initialCart));
      }
    } else {
      let filteredCart = cart.filter((item) => item._id !== e._id);
      setCartItems(filteredCart);

      localStorage.setItem("UserCart", JSON.stringify(filteredCart));
    }
    setUpdate(true);
  }

  function loadSuggestedOnly(type, page) {
    try {
      fetchStoreProduct(type, page).then((data) => {
        setSuggestedProduct([]);
        productFilter(data.data.results, setSuggestedProduct);
      });
    } catch (error) {
      setSuggestedProduct([]);
    }
  }
  function reload(type, page, withSuggested) {
    ReactGA.outboundLink(
      {
        label: `User searched item : ${(type, JSON.parse(localStorage.getItem("userQ")))}`,
      },
      function () {},
      ["Search-Tracker"],
    );

    if (!withSuggested) {
      mainCategory.current = type;
    }
    localStorage.setItem("UserCategory_Cache", JSON.stringify(type));
    setDisplaySearched(false);
    setSearchedItem(null);
    setActiveSearch(false);
    setStatus(true);
    setSelectedCategory(type);

    // Update URL
    // history.push(`/${type}`);

    // Update subcategories when main category changes
    const selectedMainCategory = categories.find((cat) => cat.title === type);
    if (selectedMainCategory && selectedMainCategory.items) {
      setSubcategories(selectedMainCategory.items);
      setSelectedSubcategory(null); // Reset subcategory selection
    } else {
      setSubcategories([]);
      setSelectedSubcategory(null);
    }

    fetchStoreProduct(type, page).then((data) => {
      setProducts([]);
      productFilter(data.data.results, setProducts);
    });
    if (withSuggested) {
      let suggested = categories.filter(
        (data) => data.title != type && data.status == true,
      );
      var item = suggested[Math.floor(Math.random() * suggested.length)];
      try {
        setSuggestedItem(item);
        fetchStoreProduct(item.title, page).then((data) => {
          setSuggestedProduct([]);
          setSuggestedProduct(data.data.results, setProducts);
        });
      } catch (error) {
        setSuggestedProduct([]);
      }
    }
  }

  function reloadSubcategory(subcategoryItem) {
    setSelectedSubcategory(subcategoryItem.title);

    // Update URL to include subcategory
    // history.push(`/${category}/${subcategoryItem.title}`);
    window.history.pushState(
      {},
      "",
      `http://localhost:3003/main=${category}&sub=${subcategoryItem.title}`,
    );
    fetchStoreProduct(subcategoryItem.title, currentPage).then((data) => {
      setProducts([]);
      productFilter(data.data.results, setProducts);
    });
  }

  function loadProductCategory() {
    let parameter = {
      id: id,
      equalTo: true,
      storeOwner: id,
      cType: "Product",
      cName: "Category",
    };
    axios
      .post("/details/Store", parameter)
      .then((response) => {
        setCategory(response.data.results[0].productCategories);
        setStoreInfo(response.data.results[0]);

        localStorage.setItem(
          "categories",
          JSON.stringify(response.data.results[0].productCategories),
        );

        setHasVoucher(
          response.data.results[0].storeOptions.siteHeaderNotice.status,
        );
        setFeaturedProducts(
          response.data.results[0].storeOptions.featuredProducts,
        );
        document.title =
          `Vivea | Timeless Blooms & Bespoke Bouquets in Iligan City` +
          response.data.results[0].storeName;
        localStorage.setItem(
          "featured_items",
          JSON.stringify(
            response.data.results[0].storeOptions.featuredProducts,
          ),
        );
        localStorage.setItem(
          "store_details",
          JSON.stringify(response.data.results[0]),
        );
      })
      .catch(function (error) {
        // Error handling silently
      });
  }
  async function fetchStoreProduct(item, page) {
    try {
      var defaultDate = new Date();
      var convertedUserDate = moment(defaultDate).format("yyyy-mm-dd");
      let userSeletedDate = localStorage.getItem("userQ");
      var date = JSON.parse(userSeletedDate);
      setSelectedDate(date);
      const data = {
        id: item,
        queryType: "filter",
        storeOwner: "6911e81042eb3f3e58494c3c",
        isAPI: true,
        showLimit: true,
        number: page,
        deliveryDate: moment(date.date).format("YYYY-MM-DD"),
      };
      const response = await axios.post("/productV2/Product", data);
      return response;
    } catch (error) {
      toast("Please try again later..");
    }
  }
  async function fetchStoreSettings(item, page) {
    try {
      var defaultDate = new Date();
      var convertedUserDate = moment(defaultDate).format("yyyy-mm-dd");
      let userSeletedDate = localStorage.getItem("userQ");
      var date = JSON.parse(userSeletedDate);
      setSelectedDate(date);
      const data = {
        id: "6953b46ceb6e18b7933e2288",
        queryType: "customV2",
        storeOwner: "6911e81042eb3f3e58494c3c",
        isAPI: true,
        showLimit: true,
        number: page,
        deliveryDate: moment(date.date).format("YYYY-MM-DD"),
      };
      const response = await axios.post("/details/StoreSettings", data);
      return response;
    } catch (error) {
      toast("Please try again later..");
    }
  }
  function renderCategories() {
    var data = [];
    categories.map((item) => {
      if (item.status) {
        data.push(
          <CategoryView
            onClick={(e) => reload(e, 8)}
            active={category}
            data={item}
          />,
        );
      }
    });
    return data;
  }
  function renderItem(source) {
    var data = [];
    var sortedProduct = source.sort(
      (a, b) => parseInt(a.price) - parseInt(b.price),
    );
    var sourceItem = sortedProduct;
    var activePromo = storeDetails.storeOptions.activeCategoryPromo[0].category;
    if (sourceItem.length) {
      sourceItem.map((item) => {
        var isAdded =
          cart.filter((data) => data._id === item._id).length === 0
            ? false
            : true;
        data.push(
          <>
            <CardV2
              activePromo={activePromo}
              type="Display"
              view={(e) => setCurrentView(e)}
              update={didUpdate}
              existing={isAdded}
              item={item}
              didAdd={(item) => addRemoveItem(item, true)}
              didRemove={(item) => addRemoveItem(item, false)}
            />
          </>,
        );
      });
      return data;
    } else {
      for (var i = 0; i < 4; i++) {
        data.push(<PlaceholderCard />);
      }
      return data;
    }
  }

  function renderDummyCards() {
    const dummyCards = [
      {
        link: "Explore/Category?main=GERBERA&sub=3232132",
        id: "tech-1",
        title: "Roses and Bouquets",
        subtitle:
          "Explore the world of technology with the interesting technology that you can see! How you have what it takes from a novice to a tech master!",
        category: "Tech",
        // bgColor: 'bg-gradient-to-br from-red-400 to-red-600',
        bgColor: "bg-white",
        textColor: "text-black",
        image:
          "https://localflowershop.sgp1.digitaloceanspaces.com/resized/resized-1621823267697-49.jpg",
      },
      {
        link: "Details/677a50086e0e2b1194443c40",
        id: "science-1",
        title: "This Week’s 20 Most Viewed",
        subtitle:
          "Discover amazing scientific breakthroughs and innovations that shape our world today",
        category: "Top 20 Most viewed of the week",
        bgColor: "bg-white",
        textColor: "text-black",
        image:
          "https://nextstage-consulting.com/wp-content/uploads/2020/03/112045804_s.jpg",
      },
      {
        link: "Details/677a50086e0e2b1194443c40",
        id: "design-1",
        title: "This Week’s Highlights",
        subtitle:
          "Creative design solutions and artistic inspiration for modern digital experiences",
        category: "Design",
        bgColor: "bg-white",
        textColor: "text-black",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYcZ2wkfjRoLH9b6kBMFIqbRAGb2U4nLWq1YRTXsN6BhFWJpvyZxMpXc5yY3-thBJ-nEI&usqp=CAU",
      },
    ];

    const scrollToCard = (index) => {
      if (dummyCardsContainerRef.current) {
        const cardWidth = 320; // 80 * 4 (w-80 = 20rem = 320px)
        const spacing = 24; // space-x-6 = 1.5rem = 24px
        const scrollPosition = index * (cardWidth + spacing);

        dummyCardsContainerRef.current.scrollTo({
          left: scrollPosition,
          behavior: "smooth",
        });
      }
    };

    return dummyCards.map((card, index) => (
      <Link to={`${card.link}`}>
        <div
          key={card.id}
          style={{ backgroundImage: card.image }}
          className="   flex-shrink-0 w-80 relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
          onClick={() => scrollToCard(index)}
        >
          <div
            className={`${card.bgColor} p-6 h-80 flex flex-col justify-between relative`}
          >
            <div className="absolute inset-0 bg-gradient-to-l from-white/90 to-transparent"></div>

            {/* Heart icon in top right */}
            <div className="absolute top-4 right-4">
              <svg
                className="w-6 h-6 text-white opacity-70 hover:opacity-100 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                  clipRule="evenodd"
                />
              </svg>
            </div>

            {/* Category badge */}
            <div className="flex justify-start">
              <span className="bg-black bg-opacity-30 text-white text-xs px-3 py-1 rounded-full font-medium">
                {card.category}
              </span>
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col justify-center">
              <h3 className={`text-2xl font-bold ${card.textColor} mb-3`}>
                {card.title}
              </h3>
              <p
                className={`${card.textColor} text-sm opacity-90 leading-relaxed`}
              >
                {card.subtitle}
              </p>
            </div>

            {/* Bottom section with image */}
            <div className="flex items-end justify-between ">
              {/* <div className="flex-1">
                <div className="flex space-x-1 mb-2">
                  <div className="w-8 h-1 bg-yellow-400 rounded"></div>
                  <div className="w-4 h-1 bg-yellow-300 rounded"></div>
                  <div className="w-2 h-1 bg-yellow-200 rounded"></div>
                </div>
              </div>*/}
              <div className="w-full h-20 rounded-lg overflow-hidden ml-4 focu ">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </Link>
    ));
  }
  const openCartView = () => {
    cartViewRef.current.openModal();
  };
  const navigateToCalendar = () => {
    setDisplayCalendar(true);
    window.scrollTo({
      top: calendarRef.current.scrollHeight,
      behavior: "smooth",
    });
    calendarRef.current.scrollTop = calendarRef.current.scrollHeight;
  };

  const navigateCategory = () => {
    window.scrollTo({
      top: categoryRef.current.scrollHeight,
      behavior: "smooth",
    });
    categoryRef.current.scrollTop = categoryRef.current.scrollHeight;
  };
  const displayNotice = () => {
    var content = <div></div>;
    if (
      storeDetails !== null &&
      storeDetails.storeOptions.siteHeaderNotice.status
    ) {
      var details = storeDetails.storeOptions.siteHeaderNotice;

      content = (
        <div
          className="sticky top-0 z-50 flex-1 overflow-y-auto  lg:h-15 sm:h-10 transform transition duration-400 "
          style={{
            backgroundColor:
              storeDetails.storeOptions.colorTheme.componentColor,
          }}
        >
          <div className="flex ... items-center justify-center w-full  mt-2 uppercase text-4 tracking-tight  font-extralight text-gray-900 ">
            {details.value}
          </div>
        </div>
      );
    }

    return content;
  };

  const loadItem = (item, page, primary) => {
    setPage(page);
    if (primary) {
      reload(item, page, false);
    } else {
      loadSuggestedOnly(item, page, true);
      setSuggestStatus(true);
    }
  };

  const validateCart = () => {
    let existingCart = localStorage.getItem("UserCart");
    if (existingCart !== null) {
      let jsonCart = JSON.parse(existingCart);
      setCartItems(jsonCart.length == 0 ? [] : jsonCart);
    } else {
      setCartItems([]);
    }
  };
  const searchService = () => {
    let parameter = {
      owner: id,
      value: searchedItem,
      deliveryDate: new Date(),
    };
    setActiveSearch(false);
    setStatus(true);
    axios
      .post("/smartSearchV2", parameter)
      .then((response) => {
        setStatus(false);
        setActiveSearch(true);
        if (response.data.results.length) {
          // setProducts([])
          setSearchResults([]);
          setDisplaySearched(true);
          productFilter(response.data.results, setSearchResults);
        } else {
          setSearchResults([]);
          setDisplaySearched(false);
        }

        // setSelectedCategory(response.data.results[0].productCategories.filter(item => item.status === true))
        // setCategory(response.data.results[0].productCategories)
        // // setTopItems(response.data.results[0].topItems)
        // console.log('response.data.results[0]',response.data.results[0])
        // setStoreInfo(response.data.results[0])
        // setHasVoucher(response.data.results[0].storeOptions.siteHeaderNotice.status)
        // document.title = 'Search results'
      })
      .catch(function (error) {
        console.log("fetching product", error);
      });
  };
  const saveDateState = (startDate, title) => {
    setSelectedDateV2(startDate);

    var convertedTime = moment(startDate).toDate();
    var searchDetails = {
      date: convertedTime,
      type: category,
    };
    localStorage.setItem("userQ", JSON.stringify(searchDetails));
    setSelectedDate(convertedTime);
  };
  const searchAvailableDateService = (e) => {
    setDisplayCalendar(false);
    localStorage.removeItem("UserCart");
    validateCart();
    reload(category, currentPage, true);
  };
  const searchComponent = () => {
    let searchResultContent = (
      <section>
        <div className="mt-10 mb-10" />
        <div
          className={
            displayCalendar
              ? "visible mt-2 transform transition duration-400"
              : "hidden"
          }
        >
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-5 gap-2 content-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="w-full" />
            <div className="border border-gray-100 w-full max-w-sm mx-auto shadow-lg rounded-lg content-center justify">
              <DatePickerComponent
                backgroundColor={displayColorBG()}
                date={selectedDateV2}
                onChangeDate={(e) => saveDateState(e)}
                validate={() => validateCart()}
                store={storeDetails}
              />
              <button
                onClick={searchAvailableDateService}
                className="text-blue-700 mb-2 font-bold w-full rounded-full"
              >
                Search available flowers
              </button>
            </div>
            <div className="w-full" />
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 group group-hover:text-red-200">
          {storeDetails === null ? null : (
            <span className="flex items-center ">
              {/* <h5 class=" text-sm  text-black/90">Available items for <span className="text-blue-400 ml-2"> {moment(selectedDate.date).format("MMMM DD YYYY").toString()}</span></h5>
     <img src="https://img.icons8.com/material-outlined/344/calendar--v1.png" className="h-4 w-4 mx-2 " /> */}
            </span>
          )}
          <div>
            <span className="inline-block w-12 h-1 bg-red-200"></span>
            <h2 className="mt-1 text-2xl font-extrabold tracking-wide uppercase lg:text-3xl">
              {searchedItem}
            </h2>
            <h5 className="text-sm text-gray-500">
              {searchedResults.length} items found
            </h5>
          </div>
          <div className="grid grid-cols-2 mt-8 lg:grid-cols-4 gap-x-4 gap-y-8">
            {storeDetails != null ? renderItem(searchedResults) : null}
          </div>
        </div>
      </section>
    );

    let emptyResults = (
      <a href="javascript:void(0);" onClick={() => setActiveSearch(false)}>
        <div className="rounded-3xl  max-w-md mx-auto relative items-center  mb-20 justify-center text-center w-full mt-10">
          <span className="text-xl font-bold  items-center ">
            '{searchedItem}'
          </span>
          <img
            className="ml-2"
            src="https://cdn.dribbble.com/users/2387623/screenshots/7026223/media/b6d3d311773a99fc8515c591cd069909.jpg?compress=1&resize=1600x1200&vertical=top"
            width={400}
            height={400}
          />
          <span className="text-xl font-bold  items-center">Not found</span>
        </div>
      </a>
    );
    const validateKeyboard = (e) => {
      if (e.key === "Enter") {
        searchService();
      }
    };

    return (
      <>
        <div class="max-w-md mx-auto "></div>
        <h5 class=" text-sm lg:ml-32  md:ml-4 ml-32 text-black/90 mb-2"></h5>
        <span>
          <h5 class="animate-bounce text-xs lg:ml-32 ml-4 text-black/20 ">
            Tap to change the date
          </h5>
        </span>
        <div
          ref={calendarRef}
          showSoftInputOnFocus={false}
          onClick={() => setDisplayCalendar(true)}
          maxLength={30}
          style={{ backgroundColor: displayColorBG() }}
          className="peer align-center justify-center items-center flex hover:shadow-lg mt-2 ease-in-out duration-300 w-auto h-10 max-w-md mx-auto lg:mx-32 outline-none text-sm text-blue-800 font-bold rounded-full border pl-4 text-white cursor-pointer"
          type="text"
          id="searchV2"
          disabled={displayCalendar}
          value={moment(selectedDateV2).format("MMMM DD YYYY").toString()} //"Choose Date "
          // disabled={status}
          onKeyDown={(e) => validateKeyboard(e)}
          onChange={(e) => setSearchedItem(e.nativeEvent.target.value)}
          placeholder="Choose Date"
        >
          <span className=" text-white">
            Order for{" "}
            {moment(selectedDateV2).format("MMM DD, YYYY").toString()}{" "}
          </span>
          <img
            alt="calendar"
            src={"/calendar@3x.png"}
            className=" rounded-sm bg-white "
            style={{
              height: 16,
              width: 16,
              marginLeft: 20,
            }}
          />
        </div>
        <div className="mt-10 mb-10" />
        <div
          className={
            displayCalendar
              ? "visible mt-2 transform transition duration-400"
              : "hidden"
          }
        >
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-5 gap-2 content-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="w-full" />
            <div className="border border-gray-100 w-full max-w-sm mx-auto shadow-lg rounded-lg content-center justify">
              <DatePickerComponent
                date={selectedDateV2}
                onChangeDate={(e) => saveDateState(e)}
                validate={() => validateCart()}
                store={storeDetails}
              />
              <button
                onClick={searchAvailableDateService}
                className="text-blue-700 mb-2 font-bold w-full rounded-full"
              >
                Search available flowers
              </button>
            </div>
            <div className="w-full" />
          </div>
        </div>
        <div className="mt-10 mb-10" />

        <h5 class=" text-sm lg:ml-32  md:ml-4 ml-32 text-black/90 mb-2"></h5>
        <span>
          <h5 class=" text-xs lg:ml-32 ml-4 text-black/20 ">
            Search by category
          </h5>
        </span>
        {displayCalendar ? null : renderCategory()}
        {searchedResults.length === 0
          ? isActiveSearch
            ? emptyResults
            : null
          : null}

        {isDisplaySearched ? searchResultContent : null}
        <div className="lg:mb-20 md:mb-40 mb-20" />
      </>
    );
    //     return (
    //       <>
    //       <div class='max-w-md mx-auto '>
    //     <span className='ml-4 mb-10 '>Searching for: <span className='font-bold'>{searchedItem}</span></span>
    //     <div class="relative ease-in-out duration-300 flex items-center w-90 lg:w-full md:w-full h-12 border-2 border-gray-500 rounded-full focus-within:shadow-lg hover:shadow-lg hover:border-black  bg-white overflow-hidden">
    //          <input
    //          maxLength={30}
    //         class="peer h-full w-full outline-none text-sm text-gray-700 pl-4"
    //         type="text"
    //         id="search"
    //         disabled={status}
    //         onKeyDown={(e)=>validateKeyboard(e)}
    //         onChange={(e)=>setSearchedItem(e.nativeEvent.target.value)}
    //         placeholder="Search for flowers/balloon" />
    //         <div class="grid place-items-center h-full w-12 text-gray-300">
    //           {status ? <div className="">
    //          <svg version="1.1" id="loader-1" className="animate-spin h-5 w-5 ml-2" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    //          width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" space="preserve">
    //          <path opacity="0.2" fill="#301B30" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    //            s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    //            c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
    //          <path fill="#301B30" className="border-white border-2" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    //            C22.32,8.481,24.301,9.057,26.013,10.047z">
    //            </path>
    //          </svg>
    //        </div> : <a href="javascript:void(0);" onClick={()=>searchService()} >
    //             <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    //             </svg>
    //             </a> }
    //         </div>
    //     </div>

    // {searchedResults.length === 0 ? isActiveSearch ?  emptyResults : null :null }
    // </div>
    // {isDisplaySearched  ?  searchResultContent : null }
    // <div className='lg:mb-40 md:mb-40 mb-20'/>
    //       </>
    //     )
  };
  const displayMainProduct = () => {
    try {
return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:text-center text-center lg:text-center my-40">
      <h1 className="uppercase text-4xl tracking-tight font-extralight text-gray-900 sm:text-2xl md:text-6xl">
        <span className="block xl:inline">
          {categories.length
            ? categories.filter((data) => data.title == category)[0]
                .displayName
            : null}
        </span>{" "}
        <span className="block text-themebg-600 xl:inline">Collection</span>
      </h1>
      <span className="block text-themebg-600 xl:inline mt-10">
        {product.length} items found
      </span>
    </div>
  );
    } catch (error) {
      return <span></span>;
    }
  };
  const renderCategory = () => {
    return (
      <div ref={categoryRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
        {renderDropDown()}
      </div>
    );
    // var list = [];
    // try {
    //   storeDetails.productCategories.map((item) => {
    //     if (item.status) {
    //       list.push(<>{categoryComponent(item)}</>);
    //     }
    //   });
    // } catch {
    //   return null;
    // }
    // return (
    //   <div>
    //     <div className="w-11/12  lg:ml-28 md:ml-20 overflow-x-visible whitespace-nowrap scroll-smooth  lg:whitespace-normal overflow-auto items-center ">
    //       {/* <div style={{overflow: "auto",whiteSpace: "nowrap"  }}>  */}
    //       {list}
    //       {/* </div> */}
    //     </div>
    //     {/* <div className="float-right " style={{top:20,right:20}}>
    //     Here
    //     </div> */}
    //   </div>
    // );
  };
  const categoryComponent = (item) => {
    return (
      <button
        onClick={() => reload(item.title, currentPage, true)}
        disabled={status === false ? false : true}
        type="button"
        className={
          1 !== 0
            ? "my-2 inline-flex hover:scroll-auto  hover:shadow-lg border-black justify-center px-4 py-2 text-sm font-medium ml-4 text-white border border-transparent rounded-full ease-in-out duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
            : "focus:ring-indigo-500 inline-flex   justify-center px-4 py-2 text-sm font-medium ml-4 text-white bg-gray-200 border border-transparent rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
        }
        style={{
          opacity: status ? (category === item.title ? 1 : 0.4) : 1,
          backgroundColor: category === item.title ? "black" : "white",
          borderColor:
            category === item.title
              ? null
              : storeDetails === null
                ? "white"
                : storeDetails.storeOptions.colorTheme.buttonColor,
          color: category === item.title ? "white" : "black",
        }}
      >
        {status ? (
          <>
            {" "}
            <div className="">
              <span className="font-sm ">{item.displayName}</span>
            </div>
            {category != item.title ? (
              <div className="">
                <span className="font-sm ml">+</span>
              </div>
            ) : (
              <div className="">
                <svg
                  version="1.1"
                  id="loader-1"
                  className="animate-spin h-5 w-5 ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="40px"
                  height="40px"
                  viewBox="0 0 40 40"
                  enable-background="new 0 0 40 40"
                  space="preserve"
                >
                  <path
                    opacity="0.2"
                    fill="#FFFF"
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
       s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
       c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                  />
                  <path
                    fill="#FFFF"
                    className="border-white border-2"
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
       C22.32,8.481,24.301,9.057,26.013,10.047z"
                  ></path>
                </svg>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="">
              <span className="font-sm ">{item.displayName} +</span>
            </div>
            <a href="javascript:void(0);"></a>{" "}
          </>
        )}
      </button>
    );

    {
      /* <svg xmlns="http://www.w3.org/2000/svg" className="lg:ml-2 md:ml-2 h-5 w-5" fill="none" viewBox="0 0 20 20" stroke="currentColor">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
</svg> */
    }
  };
  const displayColorBG = () => {
    try {
      if (storeDetails != null) {
        return (
          storeDetails?.details?.storeOptions?.colorTheme?.buttonColor ||
          "black"
        );
      } else {
        return "#ff7979";
      }
    } catch (error) {
      console.log("error in display BG", error);
      return "#ff7979";
    }
  };
  const renderBreadcrumb = () => {
    const breadcrumbItems = [];

    // Always start with Home
    breadcrumbItems.push(
      <button
        key="home"
        onClick={() => {
          setSelectedCategory(primaryProduct);
          setSelectedSubcategory(null);
          history.push("/");
        }}
        className="text-blue-600 hover:text-blue-800 text-sm font-medium"
      >
        Home
      </button>,
    );

    // Add category if selected
    if (category && category !== primaryProduct) {
      const categoryData = categories.find((cat) => cat.title === category);
      breadcrumbItems.push(
        <span key="separator1" className="text-gray-400 mx-2">
          /
        </span>,
        <button
          key="category"
          onClick={() => {
            setSelectedSubcategory(null);
            history.push(`/${category}`);
          }}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium"
        >
          {categoryData?.displayName || category}
        </button>,
      );
    }

    // Add subcategory if selected
    if (selectedSubcategory) {
      const subcategoryData = subcategories.find(
        (sub) => sub.title === selectedSubcategory,
      );
      breadcrumbItems.push(
        <span key="separator2" className="text-gray-400 mx-2">
          /
        </span>,
        <span key="subcategory" className="text-gray-700 text-sm font-medium">
          {subcategoryData?.displayName || selectedSubcategory}
        </span>,
      );
    }

    return (
      <div className="flex items-center px-4 py-2 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center text-sm">
          <svg
            className="w-4 h-4 text-gray-400 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"
            />
          </svg>
          {breadcrumbItems}
        </div>
      </div>
    );
  };

  const renderCategoryDisplayName = () => {
    try {
      return categories.length
        ? categories.filter((data) => data.title == category)[0].displayName
        : null;
    } catch (error) {
      return <>....</>;
    }
  };
  const handleNavigateCategory = React.useCallback(() => {
    navigateCategory();
  }, []);

  const handleNavigateToCalendar = React.useCallback(() => {
    navigateToCalendar();
  }, []);

  const handleOpenCartView = React.useCallback(() => {
    openCartView();
  }, []);

  const scrollSubcategoriesBack = () => {
    if (subcategoriesContainerRef.current) {
      subcategoriesContainerRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  const scrollSubcategoriesForward = () => {
    if (subcategoriesContainerRef.current) {
      subcategoriesContainerRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  const scrollCategoriesBack = () => {
    if (categoriesContainerRef.current) {
      categoriesContainerRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  const scrollCategoriesForward = () => {
    if (categoriesContainerRef.current) {
      categoriesContainerRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  const scrollDummyCardsBack = () => {
    if (dummyCardsContainerRef.current) {
      dummyCardsContainerRef.current.scrollBy({
        left: -320,
        behavior: "smooth",
      });
    }
  };

  const scrollDummyCardsForward = () => {
    if (dummyCardsContainerRef.current) {
      dummyCardsContainerRef.current.scrollBy({
        left: 320,
        behavior: "smooth",
      });
    }
  };
  // const FloatingButton = () => {
  //   return (
  //     <div
  //       // onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  //       style={{ borderColor: displayColorBG() }}
  //       className=" border  grid-cols-20 lg:w-1/4 w-9/12 md:w-9/12 fixed bottom-8 left-1/2 transform flex -translate-x-1/2 bg-white text-white text-xs py-2 px-4 rounded-full  w-[90%] shadow-lg transition-all duration-300 z-50"
  //     >
  //       <button
  //         onClick={() => navigateCategory()}
  //         className="flex align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full  transition-all duration-300 z-50"
  //       >
  //         <img
  //           src={"/square.and.pencil@3x.png"}
  //           className=""
  //           style={{
  //             height: 16,
  //             width: 16,
  //             marginLeft: 20,
  //           }}
  //         />
  //         <span className="m-2 text-black mr-4">
  //           {category.substring(0, 5)}...
  //         </span>
  //       </button>
  //       <button
  //         onClick={() => navigateToCalendar()}
  //         className="flex align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full  transition-all duration-300 z-50"
  //       >
  //         <img
  //           alt="calendar"
  //           src={"/calendar@3x.png"}
  //           className=""
  //           style={{
  //             height: 16,
  //             width: 16,
  //             marginLeft: 20,
  //           }}
  //         />
  //         <span className="lg:block hidden  m-2 text-black mr-4">
  //           {moment(selectedDate.date).format("MMM DD, YYYY").toString()}
  //         </span>

  //         <span className="lg:hidden block m-2 text-black mr-4">
  //           {moment(selectedDate.date).format("MM/DD/YY").toString()}
  //         </span>
  //       </button>
  //       <button
  //         onClick={() => openCartView()}
  //         className="flex ml-4 align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-white text-xs rounded-full transition-all duration-300 z-50"
  //       >
  //         <img
  //           src={cart.length ? "/bag.fill@3x.png" : "/bag@3x.png"}
  //           className=""
  //           style={{
  //             height: 16,
  //             width: 16,
  //             marginLeft: 10,
  //           }}
  //         />
  //         <div className="bg-white rounded-full w-6 h-6 text-red-700 text-sm flex  justify-center align-middle items-center">
  //           {cart.length}
  //         </div>
  //       </button>
  //     </div>
  //   );
  // };

  const mainContent = () => {
    return (
      <div ref={storeRef} className="max-w-7xl mx-auto">
        {/* Welcome Header Section */}
        <div className="bg-white px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-xl font-medium text-gray-900">
                Welcome back,
              </h1>
              <h2 className="text-2xl font-bold text-gray-900">
                Good Evening!
              </h2>
            </div>
            <div className="p-2">
              {/* <svg
                className="w-6 h-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg> */}
            </div>
          </div>
        </div>

        {/* Promotional Banner Section */}
        <div className="px-4 sm:px-6 lg:px-8 py-4">
          <div className="bg-white border border-gray-100 rounded-2xl p-6 relative overflow-hidden">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <Link to={"Details/66b606fc2a95e4da69e34b1a"}>
                  <h3 className="text-sm font-medium text-green-800 mb-1"></h3>

                  <h2 className="text-xl font-bold text-green-900 mb-2">
                    Elena
                  </h2>
                  <p className="text-sm text-green-800 mb-4 max-w-xs">
                    Blooms: Pink Roses, Gerberas, Carnations, and Lisianthus
                    with Eucalyptus and Misty Blue Fillers
                  </p>
                </Link>
                <Link to={"Details/66b606fc2a95e4da69e34b1a"}>
                  <button className="bg-gray-900 text-white px-4 py-2 rounded-full text-sm font-medium">
                    View now
                  </button>
                </Link>
              </div>
              <div className="flex-shrink-0 ml-4">
                <Link to={"Details/66b606fc2a95e4da69e34b1a"}>
                  <img
                    src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1723205356582-17.png"
                    alt="Elena"
                    className="w-24 h-24 object-cover rounded-lg"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Categories Section */}
        <div className="px-4 sm:px-6 lg:px-8 py-4 hidden">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Select your mood
            </h3>
            <div className="flex items-center space-x-2">
              <button
                onClick={scrollCategoriesBack}
                className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                aria-label="Scroll categories back"
              >
                <svg
                  className="w-4 h-4 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <button
                onClick={scrollCategoriesForward}
                className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                aria-label="Scroll categories forward"
              >
                <svg
                  className="w-4 h-4 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
              {/* <Link to={`Explore/Category?main=${mainIndex.category}&sub=3232132`}>
              <button
                // onClick={() =>
                //   router.push(
                //
                //   )
                // }
                className="text-sm text-gray-500"
              >
                See all
              </button>
                </Link>*/}
            </div>
          </div>
          <div
            ref={categoriesContainerRef}
            className="flex space-x-6 overflow-x-auto"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {categories
              .filter((item) => item.status && item.items?.length)
              .map((item, index) => (
                <div
                  key={item._id || index}
                  className="text-center flex-shrink-0"
                >
                  <button
                    onClick={(e) => {
                      reload(item.title, 1, true);
                      // Auto-scroll to make selected category first
                      const categoryContainer =
                        e.target.closest(".overflow-x-auto");
                      const selectedCategory =
                        e.target.closest(".flex-shrink-0");
                      if (categoryContainer && selectedCategory) {
                        const scrollLeft =
                          selectedCategory.offsetLeft -
                          categoryContainer.offsetLeft;
                        categoryContainer.scrollTo({
                          left: scrollLeft,
                          behavior: "smooth",
                        });
                      }
                    }}
                    className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-2 hover:bg-gray-200 transition-colors"
                  >
                    <span className="text-sm font-medium text-gray-600">
                      {item.displayName
                        ? item.displayName.charAt(0).toUpperCase()
                        : "C"}
                    </span>
                  </button>
                  <span className="text-xs text-gray-600">
                    {item.displayName || item.title}
                  </span>
                </div>
              ))}
          </div>
        </div>

        {/* Subcategories Section */}
        {subcategories.length > 0 && (
          <div className="flex flex-col w-full px-4 sm:px-6 lg:px-8 py-2">
            <div className="flex items-center justify-between mb-2">
              <div className="text-lg font-semibold text-gray-800">
                Available Collection
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={scrollSubcategoriesBack}
                  className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                  aria-label="Scroll subcategories back"
                >
                  <svg
                    className="w-4 h-4 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </button>
                <button
                  onClick={scrollSubcategoriesForward}
                  className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                  aria-label="Scroll subcategories forward"
                >
                  <svg
                    className="w-4 h-4 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div
              ref={subcategoriesContainerRef}
              className="flex overflow-x-auto space-x-2 scrollbar-hide"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
              {subcategories.map((subcategoryItem, index) => {
                if (!subcategoryItem.status) return null;
                return (
                  <div
                    key={subcategoryItem._id || index}
                    className="text-center flex-shrink-0"
                  >
                    <button
                      onClick={(e) => {
                        reloadSubcategory(subcategoryItem);
                        // Auto-scroll to make selected subcategory first
                        const subcategoryContainer =
                          e.target.closest(".overflow-x-auto");
                        const selectedSubcategory =
                          e.target.closest(".flex-shrink-0");
                        if (subcategoryContainer && selectedSubcategory) {
                          const scrollLeft =
                            selectedSubcategory.offsetLeft -
                            subcategoryContainer.offsetLeft;
                          subcategoryContainer.scrollTo({
                            left: scrollLeft,
                            behavior: "smooth",
                          });
                        }
                      }}
                      className={`w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-colors ${
                        selectedSubcategory === subcategoryItem.title
                          ? "bg-blue-500 text-white"
                          : "bg-gray-100 hover:bg-gray-200 text-gray-600"
                      }`}
                    >
                      <span className="text-sm font-medium">
                        {subcategoryItem.displayName
                          ? subcategoryItem.displayName.charAt(0).toUpperCase()
                          : "S"}
                      </span>
                    </button>
                    <span className="text-xs text-gray-600">
                      {subcategoryItem.displayName || subcategoryItem.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className="mt-6"></div>

        {/* New Arrivals Section */}
        <div className="px-4 sm:px-6 lg:px-8 py-4">
          {dashboardDetails
            .filter((item) => item.status === true)
            .map((main, mainIndex) => (
              <>
                <div className="flex items-center justify-between mb-4 mt-10">
                  {/* <h3 className="text-lg4 font-semibold text-gray-900">
                  {main.title}
                </h3>*/}
                  <h3 className={`text-2xl font-bold  text-gray-900 mb-3`}>
                    {main.title}
                  </h3>
                  <Link
                    to={`Explore/Category?query=subCategory&id=${main.category}&title=${main.title}`}
                  >
                    <button
                      // onClick={() =>
                      //   router.push(
                      //
                      //   )
                      // }
                      className="text-sm text-gray-500"
                    >
                      See all
                    </button>
                  </Link>
                </div>

                {main.type === "card" ? (
                  <div className="px-4 py-8">
                    <div className="flex items-center justify-between mb-6">
                      <h3 className="text-lg font-semibold text-gray-900">
                        Featured Categories
                      </h3>
                      <div className="flex items-center space-x-2">
                        {/* Back button */}
                        <button
                          onClick={scrollDummyCardsBack}
                          className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                          aria-label="Scroll dummy cards back"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 19l-7-7 7-7"
                            />
                          </svg>
                        </button>

                        {/* Forward button */}
                        <button
                          onClick={scrollDummyCardsForward}
                          className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                          aria-label="Scroll dummy cards forward"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>

                        <button className="text-sm text-gray-500 hover:text-gray-700">
                          See all
                        </button>
                      </div>
                    </div>
                    {/* Horizontal scrolling container */}
                    <div
                      ref={dummyCardsContainerRef}
                      className="flex space-x-6 overflow-x-auto pb-4 scrollbar-hide"
                      style={{
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      {renderDummyCards()}
                    </div>
                  </div>
                ) : (
                  <div className="flex space-x-4 overflow-x-auto mb-20">
                    {main.items?.map((item, index) => (
                      <div
                        key={item._id || index}
                        className="flex-shrink-0 w-40 mb-10"
                      >
                        <div className="relative">
                          <a
                            href={`/Details/${item._id}`}
                            key={item._id || index}
                          >
                            <img
                              src={
                                item.imgUrl ||
                                "https://via.placeholder.com/160x160/3b82f6/ffffff?text=Product"
                              }
                              alt={item.title || "Product"}
                              className="w-full h-40 object-cover rounded-lg mb-2"
                            />
                          </a>
                          {index === 9 && (
                            <div className="absolute top-2 left-2 bg-black text-white text-xs px-2 py-1 rounded">
                              LIMITED EDITION
                            </div>
                          )}
                          <div className="absolute top-2 right-2">
                            <svg
                              className={`w-5 h-5 ${index === 1 ? "text-white fill-current" : "text-gray-400"}`}
                              fill={index === 1 ? "currentColor" : "none"}
                              stroke={index === 1 ? "none" : "currentColor"}
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap={
                                  index === 1 ? "inherit" : "round"
                                }
                                strokeLinejoin={
                                  index === 1 ? "inherit" : "round"
                                }
                                strokeWidth={index === 1 ? 0 : 2}
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                              />
                            </svg>
                          </div>
                        </div>
                        <h4 className="text-sm font-medium text-gray-900 mb-1">
                          {item.title || "Brand"}
                        </h4>
                        <p className="text-xs text-gray-600 mb-2">
                          {item.subtitle
                            ? item.subtitle.substring(0, 20) + "..."
                            : "Product Name"}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-bold text-gray-900">
                            {new Intl.NumberFormat("en-PH", {
                              style: "currency",
                              currency: "PHP",
                            }).format(item.price)}
                          </span>
                          <button
                            onClick={() => addRemoveItem(item, true)}
                            className="w-6 h-6 bg-black rounded-full flex items-center justify-center"
                          >
                            <span className="text-white text-xs">+</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ))}
        </div>
        {/* <div className="px-4 py-4 ">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Weekly Specials
            </h3>
            <button className="text-sm text-gray-500">See all</button>
          </div>
          <div className="flex space-x-4 overflow-x-auto">
            {dashboardItems
              .find((item) => item.title === "Make love!")
              ?.items?.map((item, index) => (
                <div
                  key={item._id || index}
                  className="flex-shrink-0 w-40 mb-10"
                >
                  <div className="relative">
                    <a href={`/Details/${item._id}`} key={item._id || index}>
                      <img
                        src={
                          item.imgUrl ||
                          "https://via.placeholder.com/160x160/3b82f6/ffffff?text=Product"
                        }
                        alt={item.title || "Product"}
                        className="w-full h-40 object-cover rounded-lg mb-2"
                      />
                    </a>
                    {index === 0 && (
                      <div className="absolute top-2 left-2 bg-black text-white text-xs px-2 py-1 rounded">
                        LIMITED EDITION
                      </div>
                    )}
                    <div className="absolute top-2 right-2">
                      <svg
                        className={`w-5 h-5 ${index === 1 ? "text-white fill-current" : "text-gray-400"}`}
                        fill={index === 1 ? "currentColor" : "none"}
                        stroke={index === 1 ? "none" : "currentColor"}
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap={index === 1 ? "inherit" : "round"}
                          strokeLinejoin={index === 1 ? "inherit" : "round"}
                          strokeWidth={index === 1 ? 0 : 2}
                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <h4 className="text-sm font-medium text-gray-900 mb-1">
                    {item.brand || "Brand"}
                  </h4>
                  <p className="text-xs text-gray-600 mb-2">
                    {item.title
                      ? item.title.substring(0, 20) + "..."
                      : "Product Name"}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-bold text-gray-900">
                      ${item.price || "0.00"} USD
                    </span>
                    <button
                      onClick={() => addRemoveItem(item, true)}
                      className="w-6 h-6 bg-black rounded-full flex items-center justify-center"
                    >
                      <span className="text-white text-xs">+</span>
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>*/}

        {/* Dummy Cards Section with Horizontal Scroll */}

        {/* New Arrivals Section */}
        {/* <div className="px-4 py-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-2xl font-bold  text-gray-900">Big Day!</h3>

            <button className="text-sm text-gray-500">See all</button>
          </div>
          <div className="flex space-x-4 overflow-x-auto">
            {product.slice(0, 6).map((item, index) => (
              <div key={item._id || index} className="flex-shrink-0 w-40 mb-10">
                <div className="relative">
                  <a href={`/Details/${item._id}`} key={item._id || index}>
                    <img
                      src={
                        item.imgUrl ||
                        "https://via.placeholder.com/160x160/3b82f6/ffffff?text=Product"
                      }
                      alt={item.title || "Product"}
                      className="w-full h-40 object-cover rounded-lg mb-2"
                    />
                  </a>
                  {index === 0 && (
                    <div className="absolute top-2 left-2 bg-black text-white text-xs px-2 py-1 rounded">
                      LIMITED EDITION
                    </div>
                  )}
                  <div className="absolute top-2 right-2">
                    <svg
                      className={`w-5 h-5 ${index === 1 ? "text-white fill-current" : "text-gray-400"}`}
                      fill={index === 1 ? "currentColor" : "none"}
                      stroke={index === 1 ? "none" : "currentColor"}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap={index === 1 ? "inherit" : "round"}
                        strokeLinejoin={index === 1 ? "inherit" : "round"}
                        strokeWidth={index === 1 ? 0 : 2}
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                      />
                    </svg>
                  </div>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1">
                  {item.brand || "Brand"}
                </h4>
                <p className="text-xs text-gray-600 mb-2">
                  {item.title
                    ? item.title.substring(0, 20) + "..."
                    : "Product Name"}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-bold text-gray-900">
                    ${item.price || "0.00"} USD
                  </span>
                  <button
                    onClick={() => addRemoveItem(item, true)}
                    className="w-6 h-6 bg-black rounded-full flex items-center justify-center"
                  >
                    <span className="text-white text-xs">+</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>*/}

        {/* New Arrivals Section */}
        {/* <div className="px-4 py-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-2xl font-bold text-gray-900">
              Romance Essential
            </h3>
            <button className="text-sm text-gray-500">See all</button>
          </div>
          <div className="flex space-x-4 overflow-x-auto">
            {product.slice(0, 6).map((item, index) => (
              <div key={item._id || index} className="flex-shrink-0 w-40 mb-10">
                <div className="relative">
                  <a href={`/Details/${item._id}`} key={item._id || index}>
                    <img
                      src={
                        item.imgUrl ||
                        "https://via.placeholder.com/160x160/3b82f6/ffffff?text=Product"
                      }
                      alt={item.title || "Product"}
                      className="w-full h-40 object-cover rounded-lg mb-2"
                    />
                  </a>
                  {index === 0 && (
                    <div className="absolute top-2 left-2 bg-black text-white text-xs px-2 py-1 rounded">
                      LIMITED EDITION
                    </div>
                  )}
                  <div className="absolute top-2 right-2">
                    <svg
                      className={`w-5 h-5 ${index === 1 ? "text-white fill-current" : "text-gray-400"}`}
                      fill={index === 1 ? "currentColor" : "none"}
                      stroke={index === 1 ? "none" : "currentColor"}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap={index === 1 ? "inherit" : "round"}
                        strokeLinejoin={index === 1 ? "inherit" : "round"}
                        strokeWidth={index === 1 ? 0 : 2}
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                      />
                    </svg>
                  </div>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1">
                  {item.brand || "Brand"}
                </h4>
                <p className="text-xs text-gray-600 mb-2">
                  {item.title
                    ? item.title.substring(0, 20) + "..."
                    : "Product Name"}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-bold text-gray-900">
                    ${item.price || "0.00"} USD
                  </span>
                  <button
                    onClick={() => addRemoveItem(item, true)}
                    className="w-6 h-6 bg-black rounded-full flex items-center justify-center"
                  >
                    <span className="text-white text-xs">+</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>*/}
        <h3 className={`px-4 sm:px-6 lg:px-8 text-2xl font-bold text-gray-900 mb-3`}>
          Explore Further
        </h3>
        {storeDetails != null ? (
          <TabV3
            active={primaryProduct}
            items={storeDetails?.productCategories}
            reload={(selected) => loadItem(selected, 4, true)}
          />
        ) : null}
        {1 > 300 ? null : (
          <div className="sm:bg-white bg-white  xs:bg-white md:bg-red lg:bg-white">
            {/* {storeDetails !== null ? (
              <div className="lg:hidden md:hidden">
                <div
                  className=" bg-gray-200 mr-auto ml-auto "
                  style={{ height: 1.1, width: "90%" }}
                />
                <LandingHeader
                  didScroll={() => window.scrollTo(0, 1020)}
                  details={storeDetails}
                />{" "}
              </div>
            ) : (
              <MyLoader />
            )}*/}
            <div class="grid grid-col-3 grid-flow-col gap-3 ">
              <div class="w-full" />
            </div>
            <div className="mt-4 h-2 w-full" />

            {/* {searchComponent()}*/}
          </div>
        )}
        <span className="relative inline-block overflow-hidden rounded-full p-[1px]">
          <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#E2CBFF_0%,#393BB2_50%,#E2CBFF_100%)]" />
          <div className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-full bg-gray-950 px-3 py-1 text-xs font-medium text-gray-50 backdrop-blur-3xl">
            Badge Text
          </div>
        </span>
        {cart.length >= 1 ? (
          <CartView
            ref={cartViewRef}
            storeDetails={storeDetails}
            removeItem={(item) => addRemoveItem(item, false)}
            items={cart}
          />
        ) : null}

        <div style={{ opacity: status ? 0.2 : 1 }}>
          <div class="divide-y divide-gray-200">
            <div>
              {/* <div class="grid gap-0 lg:grid-cols-4  md:grid-cols-3  sm:grid-cols-2"></div>*/}
              <section>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 group group-hover:text-red-200">
                  {/* <div>
                    <h2 class="mt-1 text-2xl font-extrabold tracking-wide uppercase lg:text-3xl">
                      {renderCategoryDisplayName()}
                    </h2>
                  </div>*/}
                  <div className="grid grid-cols-2 mt-8 lg:grid-cols-4 gap-x-4 gap-y-8">
                    {storeDetails != null ? renderItem(product) : null}
                  </div>
                </div>
              </section>

              <div className="text-center  mb-10">
                <Link
                  to={`Explore/Category?query=type&id=${category}&title=${renderCategoryDisplayName()}`}
                >
                  {/* <button
                    // onClick={() =>
                    //   router.push(
                    //
                    //   )
                    // }
                    className="text-sm text-gray-500"
                  >
                    See all
                  </button>*/}

                  <button
                    style={{ backgroundColor: displayColorBG() }}
                    className=" text-white px-4 py-2 rounded-full text-sm font-medium"
                  >
                    See all
                  </button>
                </Link>
                {/* <button
                  disabled={status}
                  onClick={() =>
                    loadItem(
                      categories.filter((data) => data.title == category)[0]
                        .title,
                      currentPage + 100,
                      true,
                    )
                  }
                  type="button"
                  className={
                    "my-2 inline-flex  justify-center px-4 py-2 text-xs font-medium ml-4 text-white bg-black border border-transparent rounded-full hover:bg-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                  }
                  style={{
                    backgroundColor:
                      storeDetails === null
                        ? "white"
                        : storeDetails.storeOptions.colorTheme.buttonColor,
                  }}
                >
                  Show More
                  {status ? (
                    <div>
                      <svg
                        version="1.1"
                        id="loader-1"
                        className="animate-spin h-5 w-5 ml-2"
                        xmlns="http://www.w3.org/2000/svg"
                        xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="40px"
                        height="40px"
                        viewBox="0 0 40 40"
                        enable-background="new 0 0 40 40"
                        space="preserve"
                      >
                        <path
                          opacity="0.2"
                          fill="#FFFF"
                          d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                            s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                            c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                        />
                        <path
                          fill="#FFFF"
                          className="border-white border-2"
                          d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                            C22.32,8.481,24.301,9.057,26.013,10.047z"
                        ></path>
                      </svg>
                    </div>
                  ) : null}
                </button>*/}
              </div>

              {/* <section>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  {storeDetails === null ? null : (
                    <span className=" flex items-center  ">
                      {" "}
                      <h5 class=" text-sm  text-black/90 ">
                        Available items for{" "}
                        <span
                          className="text-black ml font-bold   ml rounded-full"
                          style={{ borderColor: "#ff7979" }}
                        >
                          <span className="p-2">
                            {moment(selectedDate.date)
                              .format("MMM DD, YYYY")
                              .toString()}
                          </span>
                        </span>
                      </h5>
                      <img
                        src="https://img.icons8.com/material-outlined/344/calendar--v1.png"
                        className="h-4 w-4 mx-2 "
                      />
                    </span>
                  )}
                  <div>
                    <span class="inline-block w-12 h-1 bg-red-200"></span>
                    <h2 class="mt-1 text-2xl font-extrabold tracking-wide uppercase lg:text-3xl">
                      {suggesteItem.displayName}
                    </h2>
                    <h5 class=" text-xs  text-black">
                      {suggestedProduct.length} items found
                    </h5>
                  </div>
                  <div className="grid grid-cols-2 mt-8 lg:grid-cols-4 gap-x-4 gap-y-8">
                    {storeDetails != null ? renderItem(suggestedProduct) : null}
                  </div>
                </div>
              </section>

              <div className="text-center mb-20 ">
                <button
                  disabled={status}
                  onClick={() =>
                    loadItem(suggesteItem.title, currentPage + 20, false)
                  }
                  type="button"
                  className={
                    "my-2 inline-flex  justify-center px-4 py-2 text-xs font-medium ml-4 text-white  border border-transparent rounded-full hover:bg-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                  }
                  style={{
                    opacity: status ? 0.0 : 1,
                    backgroundColor:
                      storeDetails === null
                        ? "white"
                        : storeDetails.storeOptions.colorTheme.buttonColor,
                  }}
                >
                  Show More{" "}
                  {suggestStatus ? (
                    <svg
                      version="1.1"
                      id="loader-1"
                      className="animate-spin h-5 w-5 ml-2"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="40px"
                      height="40px"
                      viewBox="0 0 40 40"
                      enable-background="new 0 0 40 40"
                      space="preserve"
                    >
                      <path
                        opacity="0.2"
                        fill="#FFFF"
                        d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                      />
                      <path
                        fill="#FFFF"
                        className="border-white border-2"
                        d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z"
                      ></path>
                    </svg>
                  ) : null}
                </button>
              </div>*/}
            </div>
          </div>

          {storeDetails !== null ? (
            <Footer details={storeDetails} />
          ) : (
            <MyLoader />
          )}
          <PopupProduct
            didAdd={(item) => addRemoveItem(item, true)}
            storeDetails={storeDetails}
            removeItem={(item) => addRemoveItem(item, false)}
            items={[1, 2, 3, 4, 5]}
          />
        </div>
      </div>
    );
  };

  const renderDropDown = () => {
    try {
      if (storeDetails != undefined) {
        let list = [];
        storeDetails.productCategories.map((item) => {
          if (item.items !== undefined) {
            if (item.items.length !== 0) {
              list.push(
                <DropDownButton
                  backgroundColor={displayColorBG()}
                  mainTitle={item.displayName}
                  items={item.items}
                  reload={(selected) =>
                    loadItem(selected.title, currentPage + 20, true)
                  }
                />,
              );
            }
          }
        });
        return list;
      } else {
      }
    } catch (error) {
      return null;
    }
  };
  const addFavouriteItem = (e) => {
    if (validateItem(e) && e.status) {
      addRemoveItem(e, true);
    } else {
      // setAdded(false)
    }
  };
  const validateItem = (e) => {
    try {
      let existingCart = localStorage.getItem("UserCart");
      var cart = JSON.parse(existingCart);
      const found = cart.find((obj) => {
        return obj._id === e._id;
      });

      let status = found === undefined ? true : false;
      return status;
    } catch (error) {
      return true;
    }
  };

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function setRandomItems(source) {
    try {
      let from = randomNumberInRange(1, source.length);
      let secondLoop = randomNumberInRange(2, source.length - 2);
      let thirdLoop = randomNumberInRange(3, source.length - 3);
      let fourthLoop = randomNumberInRange(3, source.length - 3);
      let fifthloop = randomNumberInRange(3, source.length - 3);
      let sisxthloop = randomNumberInRange(3, source.length - 3);
      const randomItem = randomNumberInRange(1, source.length);
      let item1 = source[randomNumberInRange(9, source.length)];
      let item2 = source[randomItem];
      let item3 = source[randomItem];
      let item4 = source[randomItem];
      let item5 = source[randomItem];
      let item6 = source[randomItem];
      //  setRandomProducts([source[randomNumberInRange(1,source.length)],
      //  source[randomNumberInRange(1,source.length)],
      //  source[randomNumberInRange(1,source.length)],
      //  source[randomNumberInRange(1,source.length)],
      //  source[randomNumberInRange(1,source.length)],
      //  source[randomNumberInRange(1,source.length)]])
    } catch (error) {}
  }

  const priceHandler = (e) => {
    try {
      if (e.price != undefined) {
        return new Intl.NumberFormat("en-PH", {
          style: "currency",
          currency: "PHP",
        }).format(e.price);
      }
    } catch (error) {
      return null;
    }
  };
  const displayRandomItem = () => {
    try {
      return (
        <section>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h1 className="lg:text-9xl md:text-9xl text-5xl  font-bold mt-10 lg:mt-0 md:mt-0 ">
              {storeDetails != undefined
                ? storeDetails.welcomeMessageV2.header
                : "...."}
            </h1>
            {/* <p className='mt-2 mb-2 text-md'>"Indulge in the beauty of nature with Flower Luxe Cebu's fresh and high-quality flower selections " </p> */}

            <ul className="grid grid-cols-2 gap-4 mt-8 lg:grid-cols-3">
              <li className=" hover:opacity-75">
                <a
                  href="javascript:void(0);"
                  onClick={() => addFavouriteItem(featuredProducts[0])}
                  className="relative block group"
                >
                  <img
                    src={featuredProducts[0].imgUrl}
                    alt=""
                    className="object-cover w-full rounded-lg transition duration-100 aspect-square group-hover:opacity-90"
                  />

                  <div className="absolute inset-0 flex  flex-col items-start justify-end p-6">
                    <h3 className="text-xl font-medium text-black -mt-24">
                      {priceHandler(featuredProducts[0])}
                    </h3>
                  </div>
                </a>
              </li>

              <li className=" hover:opacity-75">
                <a
                  href="javascript:void(0);"
                  onClick={() => addFavouriteItem(featuredProducts[1])}
                  className="relative block group"
                >
                  <img
                    src={featuredProducts[1].imgUrl}
                    alt=""
                    className="object-cover w-full  rounded-lg transition duration-500 aspect-square group-hover:opacity-90"
                  />
                  <div className="absolute inset-0 flex flex-col items-start justify-end p-6 ">
                    <div>
                      <h3 className="text-xl font-medium text-black ">
                        {priceHandler(featuredProducts[1])}
                      </h3>
                    </div>
                  </div>
                </a>
              </li>

              {/* RIGHT */}
              <li className="lg:grid grid-row-5 flex  grid-cols gap-4 mt-8 lg:grid-cols-2    w-full">
                {/* //LEFT */}
                <div className="">
                  <a
                    href="javascript:void(0);"
                    onClick={() => addFavouriteItem(featuredProducts[2])}
                    className="relative block group hover:shadow-lg"
                  >
                    <img
                      src={featuredProducts[2].imgUrl}
                      alt=""
                      className="object-cover w-full rounded-lg transition duration-500 aspect-square group-hover:opacity-90"
                    />
                    <div className="absolute inset-0 flex flex-col items-start justify-end ">
                      <h3 className="text-md font-medium text-black ">
                        {priceHandler(featuredProducts[2])}
                      </h3>
                    </div>
                  </a>
                  <a
                    href="javascript:void(0);"
                    onClick={() => addFavouriteItem(featuredProducts[3])}
                    className="relative block group"
                  >
                    <img
                      src={featuredProducts[3].imgUrl}
                      alt=""
                      className="object-cover w-full rounded-lg transition duration-500 aspect-square group-hover:opacity-90"
                    />
                    <div className="absolute inset-0 flex flex-col items-start justify-end ">
                      <h3 className="text-md font-medium text-black ">
                        {priceHandler(featuredProducts[3])}
                        {/* {featuredProducts[0].title} */}
                      </h3>
                      {/* <span
                    className="mt-1.5 inline-block bg-black rounded-full px-5 py-3 text-xs font-medium uppercase tracking-wide text-white"
                  >
                   Order me for tomorrow?xxxx
                  </span> */}
                    </div>
                  </a>
                </div>

                {/* RIGHT */}

                <div className="">
                  <a
                    href="javascript:void(0);"
                    onClick={() => addFavouriteItem(featuredProducts[4])}
                    className="relative block group hover:shadow-lg"
                  >
                    <img
                      src={featuredProducts[4].imgUrl}
                      alt=""
                      className="object-cover w-full rounded-lg transition duration-500 aspect-square group-hover:opacity-90"
                    />
                    <div className="absolute inset-0 flex flex-col items-start justify-end ">
                      <h3 className="text-md font-medium text-black ">
                        {priceHandler(featuredProducts[4])}
                      </h3>
                    </div>
                  </a>
                  <a
                    href="javascript:void(0);"
                    onClick={() => addFavouriteItem(featuredProducts[5])}
                    className="relative block group"
                  >
                    <img
                      src={featuredProducts[5].imgUrl}
                      alt=""
                      className="object-cover w-full rounded-lg transition duration-500 aspect-square group-hover:opacity-90"
                    />
                    <div className="absolute inset-0 flex flex-col items-start justify-end bottom">
                      <h3 className="text-md font-medium text-black ">
                        {priceHandler(featuredProducts[5])}
                      </h3>

                      {/* <span
        className="mt-1.5 inline-block bg-black rounded-full px-5 py-3 text-xs font-medium uppercase tracking-wide text-white"
      >
       Order me for tomorrow?xxxx
      </span> */}
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div className="flex items-center text-center justify-center">
            {/* <h1 className='mt-4 mb-10 text-md
        '> */}
            <h5 class="mt-4 mb-10  text-sm  text-black/90">
              Featured Products
            </h5>
          </div>
        </section>
      );
    } catch (error) {
      return (
        <button
          className="text-xs  border-2 h-10 w-auto rounded-full border-black  mt-10 lg:ml-20 ml-4"
          onClick={() => window.location.reload(true)}
        >
          <div className="mr-2 ml-2"> Tap to refresh</div>
        </button>
      );
    }
  };
  return (
    <>
      <StoreHelmet />
      <html class="" style={{ scrollBeha: "smooth" }}>
        <div className=" w-full " />
        <div className=" w-full h-20  ">
          <CalendarV2
            openCart={() => handleOpenCartView()}
            onChangeDate={(e) => saveDateState(e)}
            validate={() => validateCart()}
          />
          <MegaMenu />

          {/* <div className=' bg-gray-200 mr-auto ml-auto ' style={{height:1.1,width:'90%'}}/> */}
          {mainContent()}
          {/* <FloatingButton /> */}
          {/* Your other components */}
          {/* <FloatingButton
            category={category}
            selectedDate={selectedDate}
            cart={cart}
            displayColorBG={displayColorBG}
            navigateCategory={handleNavigateCategory}
            navigateToCalendar={handleNavigateToCalendar}
            openCartView={handleOpenCartView}
            selectedDateV2={selectedDateV2}
            offset={offset}
          />*/}
          <div
            className=" w-full h-20 "
            style={{ backgroundColor: displayColorBG() }}
          >
            <div className=" w-full h-20 bg-white rounded-br-full rounded-bl-full" />
          </div>
        </div>
      </html>
    </>
  );
}

export default App;

{
  /* <div className={hasVoucher ? "sticky top-5 sm:top-10  z-10 flex-1 overflow-y-auto  lg:h-15 sm:h-10  transform transition duration-400" : "shadow transform transition duration-400 sticky top-0 z-10  lg:h-15 sm:h-10 xs:h-5  "} style={{ backgroundColor: 'white' }}>
        <div class="flex ... items-center   lg:justify-center   overflow-y-auto overflow-x-auto " >
          {categories.length ? renderCategories() : <CategoryPH />}
        </div>
      </div> */
}
